import { Grid } from '@material-ui/core';
import { btn_next, btn_prev } from 'components/base/images';
import useInput from 'lib/hooks/useInput';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DashboardActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import styled from 'styled-components';
import { color } from 'styles/utils';
import Calendar from 'react-calendar';
import 'styles/lib/reactCalendar.css';
import CustomSpan from 'components/common/text/CustomSpan';
import { useDidUpdateEffect } from 'lib/utils';
import T from 'components/common/text/T';
import DonutChart from 'components/common/chart/DonutChart';
import CircularLoading from 'components/base/loading/CircularLoading';
import ListEmpty from 'components/common/list/ListEmpty';
import { PageSubTitle } from 'components/base/title/PageTitle';
interface ScheduleContainerProps {
  className?: string;
}

export interface IDuedateCount {
  day: number;
  month: number;
  week: number;
}

export interface IStageCount {
  completed: number;
  new: number;
  progress: number;
}

function ScheduleContainer({ className }: ScheduleContainerProps) {
  const {
    scheduleData: { duedateCount: scheduleDuedateCount, stageCount: scheduleStageCount },
    scheduleDataSuccess,
    scheduleDataPending,
    scheduleDataFailure,
    language,
  }: {
    scheduleData: { duedateCount: IDuedateCount; stageCount: IStageCount };
    scheduleDataSuccess: boolean;
    scheduleDataPending: boolean;
    scheduleDataFailure: boolean;
    language: string;
  } = useShallowAppSelector(state => ({
    scheduleData: state.dashboard.schedule.data || {},
    scheduleDataSuccess: state.dashboard.schedule.success,
    scheduleDataPending: state.dashboard.schedule.pending,
    scheduleDataFailure: state.dashboard.schedule.failure,
    language: state.base.language,
  }));
  const [isLoadSuccess, setIsLoadSuccess] = useState<boolean>(false);
  const [isLoadFailure, setIsLoadFailure] = useState<boolean>(false);
  // state
  const date = useInput(new Date());
  const calendarMark = ['2021-11-01', '2021-11-10', '2021-11-15'];

  // chart
  const projectChart = [
    { title: 'Complete', value: scheduleStageCount?.completed || 0, color: '#25256f' },
    { title: 'Progress', value: scheduleStageCount?.progress || 0, color: '#00a6e2' },
    { title: 'None', value: scheduleDuedateCount?.day > 0 ? 0 : 1, color: '#e1e1e7' },
  ];

  const handleRefreshList = () => {
    DashboardActions.fetch_schedule_request({
      searchDate: moment(date.value).format('YYYY-MM-DD'),
    });
    setIsLoadSuccess(false);
    setIsLoadFailure(false);
  };

  useEffect(() => {
    DashboardActions.fetch_schedule_request({
      searchDate: moment(date.value).format('YYYY-MM-DD'),
    });
    return () => {
      setIsLoadSuccess(false);
      setIsLoadFailure(false);
    };
  }, []);

  useDidUpdateEffect(() => {
    DashboardActions.fetch_schedule_request({
      searchDate: moment(date.value).format('YYYY-MM-DD'),
    });
  }, [date.value]);

  useDidUpdateEffect(() => {
    if (!scheduleDataSuccess) return;
    setIsLoadSuccess(true);
  }, [scheduleDataSuccess]);
  useDidUpdateEffect(() => {
    if (!scheduleDataFailure) return;
    setIsLoadFailure(true);
  }, [scheduleDataFailure]);

  return (
    <StyledSchedule data-component-name="StyledSchedule" item className={className}>
      <div className="dashboard__card_title_box">
        <PageSubTitle title="HOME_TITLE_SCHEDULE" margin="0" />
        {/* <h3 className="dashboard__card_title">
          <T>HOME_TITLE_SCHEDULE</T>
        </h3> */}
      </div>

      <div className="dashboard__schedule_content_box box-shadow-default">
        <div className="dashboard__calendar_box">
          <Calendar
            value={date.value}
            onChange={(value: any) => date.setValue(value)}
            calendarType="US"
            locale={language}
            className="dashboard__calendar"
            tileClassName={({ date, view }): string | any => {
              let returnClassName = '';
              if (moment(date).diff(moment(), 'd') < 0) {
                returnClassName = returnClassName + ' lastday';
              }
              if (calendarMark.find(x => x === moment(date).format('YYYY-MM-DD'))) {
                returnClassName = returnClassName + ' workday';
              }
              return returnClassName;
            }}
            prevLabel={<img src={btn_prev} />}
            nextLabel={<img src={btn_next} />}
            showFixedNumberOfWeeks
            formatDay={(locale, date) => moment(date).format('D')}
          />
        </div>
        <div className="dashboard__projects">
          <div className="dashboard__today">
            <div className="dashboard__today_title">
              <CustomSpan fontSize={20} fontColor="#25256f" fontWeight={500} marginRight={12}>
                {language === 'en'
                  ? moment(date.value).locale(language).format('DD MMM')
                  : moment(date.value).locale(language).format('MM/DD')}
              </CustomSpan>
              <CustomSpan fontSize={16} fontColor="#25256f" fontWeight={300}>
                <T>HOME_SCHEDULE_DUE_DATE_PROJECT</T>
              </CustomSpan>
            </div>

            <div className="dashboard__today_total">
              {!isLoadSuccess && !!scheduleDataPending && (
                <div className="infinite-scroll-loading">
                  <CircularLoading />
                </div>
              )}
              {!!isLoadSuccess && (
                <>
                  <div className="dashboard__today_chart">
                    <DonutChart
                      data={projectChart as any}
                      width={200}
                      lineWidth={40}
                      labelVisible={
                        scheduleDuedateCount?.day > 0 &&
                        projectChart[0]?.value > 0 &&
                        projectChart[1]?.value > 0
                      }
                      startAngle={
                        scheduleDuedateCount?.day > 0
                          ? -90 -
                            (360 * projectChart[0]?.value) /
                              (projectChart[0]?.value + projectChart[1]?.value)
                          : 0
                      }
                      paddingAngle={0}
                      labelPosition={80}
                      radius={50}
                      segmentsShift={1}
                    >
                      <div className="dashboard__today_label">
                        <CustomSpan fontSize={14} fontColor="#0c1c5d" fontWeight={300}>
                          <T>HOME_SCHEDULE_DAY_PROJECT</T>
                        </CustomSpan>
                        <CustomSpan
                          testId="schedule_day_count"
                          fontSize={37}
                          fontColor="#0c1c5d"
                          fontWeight={300}
                        >
                          {scheduleDuedateCount?.day}
                        </CustomSpan>
                      </div>
                    </DonutChart>
                  </div>
                  <div className="dashboard__today_chart_info">
                    <div className="dashboard__today_chart_info_label">
                      <span
                        className="dashboard__today_chart_info_circle"
                        style={{
                          backgroundColor: projectChart[1]?.color,
                        }}
                      />
                      <CustomSpan fontSize={14} fontWeight="normal">
                        <T>HOME_SCHEDULE_PROGRESS</T>
                      </CustomSpan>
                    </div>
                    <div className="dashboard__today_chart_info_label">
                      <span
                        className="dashboard__today_chart_info_circle"
                        style={{
                          backgroundColor: projectChart[0]?.color,
                        }}
                      />
                      <CustomSpan fontSize={14} fontWeight="normal">
                        <T>HOME_SCHEDULE_COMPLETE</T>
                      </CustomSpan>
                    </div>
                  </div>
                </>
              )}
              {!!isLoadFailure && (
                <ListEmpty
                  text="GLOBAL_LIST_ERROR"
                  isRefreshButton={true}
                  onRefresh={handleRefreshList}
                />
              )}
            </div>
          </div>
          <div className="dashboard__week_month">
            <div className="dashboard__week">
              <div className="dashboard__week_label">
                <CustomSpan fontSize={14} fontWeight="normal" fontColor="#25256f" marginRight={12}>
                  <T>HOME_SCHEDULE_WEEK_PROJECT</T>
                </CustomSpan>
                <CustomSpan
                  fontSize={24}
                  fontWeight="normal"
                  fontColor="#25256f"
                  testId="schedule_week_count"
                >
                  {scheduleDuedateCount?.week}
                </CustomSpan>
              </div>
            </div>
            <div className="dashboard__month">
              <CustomSpan fontSize={14} fontWeight="normal" fontColor="#25256f" marginRight={12}>
                <T>HOME_SCHEDULE_MONTH_PROJECT</T>
              </CustomSpan>
              <CustomSpan
                fontSize={24}
                fontWeight="normal"
                fontColor="#25256f"
                testId="schedule_month_count"
              >
                {scheduleDuedateCount?.month}
              </CustomSpan>
            </div>
          </div>
        </div>
      </div>
    </StyledSchedule>
  );
}

const StyledSchedule = styled(Grid)`
  .dashboard__schedule_content_box {
    display: flex;
    height: 360px;
    border-radius: 10px;
    overflow: hidden;
  }
  .dashboard__calendar_box {
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 405px;
    height: 100%;
    padding: 30px;
    background-color: white;
    border-right: solid 1px #e1e1e7;
    .dashboard__calendar {
      width: 100%;
      border: none;
    }
    .dashboard__calendar_projects {
      padding: 12px 0;
      background-color: #f4f5fa;
      border-radius: 5px;
      font-size: 13px;
      text-align: center;
      b {
        margin-right: 15px;
      }
      span {
        margin: 0 5px;
      }
    }
  }
  .dashboard__projects {
    width: 405px;
    height: 100%;
    display: flex;
    background-color: white;
    flex-direction: column;
    .dashboard__today {
      padding: 30px;
      background-color: white;
      .dashboard__today_title {
        font-weight: 300;
        margin-bottom: 20px;
      }
      .dashboard__today_total {
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 30px;
        width: 100%;
        height: 200px;
        position: relative;
        .dashboard__today_chart {
          .dashboard__today_label {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            flex-direction: column;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            height: 100%;
          }
        }
        .dashboard__today_chart_info {
          .dashboard__today_chart_info_circle {
            display: inline-block;
            margin-right: 10px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: ${color.blue};
          }
          .dashboard__today_chart_info_label {
            margin-bottom: 7px;
          }
        }
      }
    }
    .dashboard__week_month {
      display: flex;
      border-top: solid 1px #e1e1e7;
      height: 100%;
      padding: 10px 0;
      .dashboard__week,
      .dashboard__month {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        .dashboard__week_label,
        .dashboard__month_label {
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 300;
        }
      }
      .dashboard__week {
        border-right: solid 1px #e1e1e7;
      }
    }
  }
`;

export default React.memo(ScheduleContainer);
